// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"e8dec7efcdc6dc08","888":"de712d8de4f1c879"}[chunkId] + ".css";
};